/**
 * RouteTimeline — vertical start / via / end route summary for trip detail.
 */
import styled from "styled-components";
import { getRouteTimelinePoints } from "../utils/tripFormatters.js";

const ACCENT = "#e3292f";

const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;

const Timeline = styled.div`
  position: relative;
  padding-left: 28px;
`;

const Line = styled.div`
  position: absolute;
  left: 9px;
  top: 12px;
  bottom: 12px;
  width: 2px;
  background: #e2e8f0;
`;

const Stop = styled.div`
  position: relative;
  padding: 10px 0;

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 0;
  }
`;

const Dot = styled.span`
  position: absolute;
  left: -28px;
  top: 14px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid ${({ $active }) => ($active ? ACCENT : "#cbd5e1")};
  background: ${({ $active }) => ($active ? ACCENT : "#fff")};
`;

const StopLabel = styled.div`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #94a3b8;
  margin-bottom: 2px;
`;

const StopValue = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: #111827;
`;

const MapLink = styled.button`
  margin-top: 16px;
  padding: 0;
  border: none;
  background: none;
  color: ${ACCENT};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-align: left;

  &:hover {
    text-decoration: underline;
  }
`;

const RouteTimeline = ({ corridor, onViewMap }) => {
  const { start, via, end } = getRouteTimelinePoints(corridor);

  if (!start && !end) {
    return <StopValue>Route not set</StopValue>;
  }

  const stops = [
    start ? { label: "Start", value: start, active: true } : null,
    ...via.map((value) => ({ label: "Via", value, active: false })),
    end ? { label: "End", value: end, active: true } : null,
  ].filter(Boolean);

  return (
    <Card>
      <Timeline>
        <Line />
        {stops.map((stop) => (
          <Stop key={`${stop.label}-${stop.value}`}>
            <Dot $active={stop.active} />
            <StopLabel>{stop.label}</StopLabel>
            <StopValue>{stop.value}</StopValue>
          </Stop>
        ))}
      </Timeline>
      {onViewMap ? (
        <MapLink type="button" onClick={onViewMap}>
          View full route on map →
        </MapLink>
      ) : null}
    </Card>
  );
};

export default RouteTimeline;
